import React, {useState} from "react";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import { FaCheck } from "react-icons/fa6";
import { MdArrowDropDown, MdArrowDropUp } from "react-icons/md";
import useOutsideClickHandler from "hooks/useOutsideClickHandler";
import './index.css';

type IndexFilter = {
    'All questions': number;
    'Flagged': number;
    'Answered': number;
    'Unanswered': number;
};

type Dropdown4Props = {
    children?: React.ReactNode;
    className?: string;
    data: IndexFilter; 
    instruction?: boolean;
    dataKey?: string;
    onSelect: (value: any) => void;
    placeholder?: string;
    required?: boolean;
    value?: any;
    isOpen: boolean;
    setIsOpen?: (value: any) => void;
}

function Dropdown4 ({
    children,
    className,
    data,
    instruction,
    dataKey,
    onSelect,
    placeholder,
    value,
    isOpen,
    setIsOpen
}: Dropdown4Props) {
    const ref = useOutsideClickHandler(()=> setIsOpen && setIsOpen(false));

    const selectItem = (item: any) => {
        onSelect(item);
    }

    return (
        <div
            className={isOpen
                ? `dropdown4--open ${className}`
                : `dropdown4 ${className}`
            }
            ref={ref}
        >
            <div 
                className={isOpen
                    ? "dropdown4__value--selected" 
                    : "dropdown4__value" 
                }
                onClick={() => setIsOpen(!isOpen)}
            >
                {value
                    ?   <p>{value.toUpperCase()}</p>
                    :   placeholder
                    ?   <p className="dropdown4__placeholder">
                          {placeholder}
                        </p>
                    :   ''
                }
                {isOpen &&
                    <div className="dropdown4__items">
                        {Object.entries(data).map(([key, count], i) => (
                            <div className="dropdown4__itemContainer" onClick={()=> selectItem(key)}>
                                <div className="dropdown4__checkIcon">
                                    {value === key && <FaCheck />}
                                </div>
                                <div className="dropdown4__itemContent">
                                    <p
                                        key={i}
                                        className={ value === key
                                            ? 'dropdown4__item dropdown4__itemSelected'
                                            : 'dropdown4__item'
                                        }
                                    >
                                        {dataKey ? key[dataKey] : key}

                                    </p>
                                    <div className="dropdown4__count">
                                        {/* ({instruction ? count+1 : count}) */}
                                        ({count})
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                }
                {isOpen
                    ? <MdArrowDropUp className={isOpen? 'dropdown4__icon--selected':'dropdown4__icon'} />
                    : <MdArrowDropDown className='dropdown4__icon' />
                }
            </div>
        </div>
    )
}

export default Dropdown4;